//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_GK,
  TITLE_COLOR_GK,
  WHATS_APP_COLOR,
} from "./utils/colors";

//IMPORT NUMBERS
import { WHATS_APP_LINK, WHATS_APP_TEXT } from "./utils/phoneNumbers";

//GOOGLE ANALYTICS
//import { TRACKING_ID } from "./utils/ga";

//import ReactGA from "react-ga4";
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import PagesRoutes from "./Routes/routes";
import PolicyModal from "./components/PolicyModal";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import "./App.css";

export default function App() {
  useEffect(() => {
    const loader = document.getElementById("loading-page");
    loader.style.display = "none";
    //ReactGA.initialize(TRACKING_ID);
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <WhatsAppButton
          white={WHITE}
          whatsAppColor={WHATS_APP_COLOR}
          whatsAppNumber={WHATS_APP_LINK}
        />
        <PolicyModal
          white={WHITE}
          textColor={TEXT_COLOR}
          btnColor={PRIMARY_BTN_GK}
          titleColor={TITLE_COLOR_GK}
        />
        <Header
          white={WHITE}
          btnColor={PRIMARY_BTN_GK}
          whatsAppNumber={WHATS_APP_LINK}
          whatsAppText={WHATS_APP_TEXT}
        />
        <PagesRoutes />
        <Footer
          white={WHITE}
          whatsAppNumber={WHATS_APP_LINK}
          whatsAppText={WHATS_APP_TEXT}
        />
      </BrowserRouter>
    </HelmetProvider>
  );
}
